module.exports = "/_next/static/images/avatar2-c2173ad9d2b80548ffc80a3d2d7a0b20.jpg";